export default __webpack_public_path__ + "static/media/1903.90bd6df4.png";